import { render, staticRenderFns } from "./invite-rules.vue?vue&type=template&id=57f450c8&scoped=true&"
import script from "./invite-rules.vue?vue&type=script&lang=js&"
export * from "./invite-rules.vue?vue&type=script&lang=js&"
import style0 from "./invite-rules.vue?vue&type=style&index=0&id=57f450c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f450c8",
  null
  
)

export default component.exports